import Vue from 'vue';
import Vuex from 'vuex';
// eslint-disable-next-line import/no-cycle
import storeConfig from './storeConfig';

Vue.use(Vuex);

export default new Vuex.Store(storeConfig);
